"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIREBASE_CONFIG = void 0;
exports.FIREBASE_CONFIG = {
    apiKey: "AIzaSyBuy0MzmG5Wk49N-28ljq6YGxD1e3FY4vQ",
    authDomain: "viralarc.ai",
    projectId: "gen-lang-client-0414687610",
    storageBucket: "gen-lang-client-0414687610.firebasestorage.app",
    messagingSenderId: "450343397052",
    appId: "1:450343397052:web:df6105f72c67f8a54a52b9",
    measurementId: "G-60VYRWZEND"
};
